<!-- 
    描述：评价记录详情页
    编辑于     2022-5-20 14:21:51
    编辑人     钱磊
-->
<template>
  <div class="filed-info-layout">
    <div class="common-top" ref="formRef">
      <div class="card-area">
        <el-form :model="detailData" label-width="140px">
          <el-row>
            <el-col :span="7">
              <el-form-item label="流水号：">
                <div class="text-overflow">
                  {{ detailData.serialNo ? detailData.serialNo : "-" }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="评价时间：">
                <div class="text-overflow">
                  {{ detailData.createDate ? detailData.createDate : "-" }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="业务来源：">
                <div class="text-overflow">
                  {{ detailData.resourceName ? detailData.resourceName : "-" }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <el-form-item label="评价项目：">
                <div class="text-overflow">
                  {{ detailData.assProject ? detailData.assProject : "-" }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="引用规则名称：">
                <div class="text-overflow">
                  {{ detailData.ruleName ? detailData.ruleName : "-" }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <el-form-item label="评价方：">
                <div class="text-overflow">
                  {{ detailData.assName ? detailData.assName : "-" }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="证件号：">
                <div class="text-overflow">
                  {{ detailData.assNo ? detailData.assNo : "-" }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <el-form-item label="评价方业务角色：">
                <div class="text-overflow">
                  {{ detailData.assRole ? detailData.assRole : "-" }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="评价方类型：">
                <div class="text-overflow">
                  {{ detailData.assType ? "企业" : "个人" }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <el-form-item label="被评价方：">
                <div class="text-overflow">
                  {{ detailData.beAssName ? detailData.beAssName : "-" }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="证件号：">
                <div class="text-overflow">
                  {{ detailData.beAssNo ? detailData.beAssNo : "-" }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <el-form-item label="被评价方业务角色：">
                <div class="text-overflow">
                  {{ detailData.beAssRole ? detailData.beAssRole : "-" }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="被评价方类型：">
                <div class="text-overflow">
                  {{ detailData.beAssType ? "企业" : "个人" }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-row class="mt20">
        <h5>评价细则：</h5>
        <el-divider></el-divider>
      </el-row>
      <div class="table mt20">
        <vxe-table
          ref="xTable"
          :data="filterData"
          size="small"
          highlight-current-row
          border
        >
          <vxe-table-column
            field="itemName"
            title="评价项目"
            header-align="center"
            show-overflow-tooltip
            width="180"
          ></vxe-table-column>
          <vxe-table-column
            field="sname"
            title="单项"
            align="center"
            width="200"
          >
            <template v-slot="{ row }">
              <el-rate v-model="row.score" disabled></el-rate>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="score"
            title="单项分数"
            align="center"
            width="180"
          >
            <template v-slot="{ row }"> {{ row.score }}分 </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getAssessRecordDetail } from "api/modules/assessment-system/AssessmentRecords";
export default {
  data() {
    return {
      detailData: {},//详情数据
      filterData: [],//评价细则
    };
  },
  created() {
    // if (this.$getSessionItem("detailData")) {
    //   this.detailData = JSON.parse(this.$getSessionItem("detailData"));
    // }
    this.getData();
  },
  methods: {
    // 获取详情数据
    getData() {
      let arr = {
        id: this.$route.query.id,
      };
      getAssessRecordDetail(arr)
        .then((res) => {
          this.detailData = res.data;
          this.filterData = res.data.details;
            let _item = this.yyyw.filter(val=>{
              return val.value == this.detailData.resource
            })
            this.detailData.resourceName=_item[0].sname
        })
        .catch((err) => {});
    },
  },
  computed: {
    ...mapState("dict", {
      yyyw: (state) => state.yyyw,
      pjwd: (state) => state.pjwd,
    }),
  }
};
</script>

<style lang='less' scoped>
.filed-info-layout {
  .common-top {
    padding: 20px 0;
    .el-form-item {
      margin-bottom: 0;
    }
    .el-divider--horizontal {
      margin: 8px 0;
      background: 0 0;
      border-top: 1px dashed #999;
    }
    .table {
      width: 560px;
    }
  }
}
</style>